<template>
  <v-app>
    <v-main>
      <v-container>
        <v-stepper flat v-model="e1">
          <v-stepper-header>
            <v-stepper-step color="#e50914" :complete="e1 > 1" step="1">
              Profile Information
            </v-stepper-step>

            <v-divider></v-divider>

            <v-stepper-step color="#e50914" :complete="e1 > 2" step="2">
              Payment Details
            </v-stepper-step>

            <v-divider></v-divider>

            <v-stepper-step color="#e50914" step="3">
              Customization
            </v-stepper-step>
          </v-stepper-header>

          <v-stepper-items>
            <v-stepper-content step="1">
              <ProfileDetails @toPayment="toPayment" />
              <!-- <v-btn @click="seeTemplate()">Test Template</v-btn> -->
            </v-stepper-content>

            <v-stepper-content step="2">
              <PaymentDetails
                @goBack="goBack"
                @toCustomization="toCustomization"
                @activateOverlay="activateOverlay"
                @deactivateOverlay="deactivateOverlay"
              />
            </v-stepper-content>

            <v-stepper-content step="3">
              <Customization 
               @goBack="goBack"
              :loading="loading" @submit="submit" />
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
      </v-container>
    </v-main>
    <v-overlay :absolute="absolute" opacity="0.7" :value="overlayLoading">
      <v-progress-circular
        :size="100"
        :width="5"
        color="#e50914"
        indeterminate
      ></v-progress-circular>
      <p class="text-center">Resolving Bank</p>
    </v-overlay>

    <v-overlay
      style="text-align:center"
      :absolute="absolute"
      opacity="0.7"
      :value="loading"
    >
      <v-progress-circular
        :size="80"
        :width="5"
        color="#e50914"
        class="text-center"
        indeterminate
      ></v-progress-circular>
      <p class="text-center">Setting up account, please wait...</p>
    </v-overlay>
  </v-app>
</template>

<script>
import { mapGetters } from "vuex";
import db from "@/db";
import { getAuth, updateProfile } from "firebase/auth";
import { doc, getDoc, setDoc } from "firebase/firestore";
import ProfileDetails from "@/components/ProfileDetails";
import PaymentDetails from "@/components/PaymentDetails";
import Customization from "@/components/Customization";
import axios from "axios";
import moment from "moment";

export default {
  name: "Setup",
  components: {
    ProfileDetails,
    PaymentDetails,
    Customization
  },
  data() {
    return {
      e1: 1,
      person: "",
      country: "",
      bio: "",
      name: "",
      email: "",
      bank: "",
      absolute: true,
      overlayLoading: false,
      color: "",
      bg: "",
      loading: false,
      image: "",
      uid: "",
      notificationsPayLoad: ""
    };
  },
  computed: {
    ...mapGetters({
      user: "user"
    })
  },

  metaInfo: {
    title: "Account Setup",
    titleTemplate: "%s | Tippings ",
    meta: [
      {
        name: "description",
        content: "Seamlessly get rewarded for your creativity on Tippings"
      },
      {
        property: "og:title",
        content: " Account Setup | Tippings"
      },
      { property: "og:site_name", content: "Tippings" },
      {
        property: "og:description",
        content: "Seamlessly get rewarded for your creativity on Tippings"
      },
      { property: "og:type", content: "profile" },
      {
        property: "og:url",
        content: "https://tippings.me/"
      },
      { property: "og:image", content: "" }
    ]
  },

  created() {
    this.$vuetify.theme.dark = false;
    if (localStorage.getItem("tippingsKey") != null) {
      this.$router.push("/dashboard");
    }
  },
  methods: {
    goBack(){
     this.e1--
    },
    seeTemplate(){
     let payLoad = {username:"tell"}
      axios({
              method: "post",
              url: "https://tips-api.herokuapp.com/mail",
              data: {
                from: "Teniola from Tippings <support@tippings.me>",
                email: "toheebojuolape7@gmail.com",
                replyTo: "support@tippings.me",
                title: "Welcome To Tippings 🎉",
                message: `
                  <div style="line-height:2.2;margin:0px 30px 0px 30px">
          <div style="text-align:center;width:50%:margin:auto">
          <div style=" text-align: center; width:300px; margin:auto auto 20px auto"> 
          <div style="position: relative;top: 10px;color: white;font-size: 13px;background: white;display: inline-block;padding: 0 20px;border-radius: 30px;">
          <img src="https://i.ibb.co/g7QwRGg/T.png" width="60px" height="60px" style="width:60px;text-align:center;margin:auto;border-radius:50%"/>
          </div>
          <div style="margin-top:20px;height:1px;background:black"></div>
        </div>
         </div>
                  <h1>Hi ${this.name}</h1> 
            <p>Thank you for taking the bold step of creating a Tippings account. We assure you that from this moment forward your journey as an African content creator will not remain the same </p>
            
            <h2>What can you do on Tippings?</h2>
            <p>✓ Build and grow an audience that truly love your content</p>
            <p>✓ Seamlessly gain support and raise funds from your community </p>
            <p>✓ Build an emaillist and send out emails to your fans, for FREE!</p>
            <p>✓ Customize your Tippings page and showcase your creativity </p>

            <p style="margin-top:50px;margin-bottom:53px;text-align:center">To start customizing your Tippings page, tap the button below:
            <a style="color:white;text-decoration:none" href='https://tippings.me/${payLoad.username}'><p style="border-radius:12px;margin:auto;background:red;color:white;padding:19px 25px 19px 25px;width:165px">Customize your page </p></a>
            </p>
            
            <p style="margin-top:30px">If you need any support or have any complaints, please shoot an email to <a href="mailto:support@tippings.me">support@tippings.me</a>
            
            <br><br><p>Your personal assistant<br>Teniola</p>
             
             
             <div style="border:solid 4px black;background:black,color:white,padding:400px;display:flex">
          <div style="margin-top:60px;background-color: red; color: black; text-align: center; padding: 30px 20px 30px 20px;">
          <p style="text-align: center; color: white;">


          <a style="color: #000000;margin-right:15px" href="https://facebook.com/tell.com.ng">
          <img class="alignnone wp-image-28420" src="https://i.ibb.co/FzDN2DT/facebook-1.png" alt="" width="22" height="22" />
          </a>
          
          
          <a style="color: #000000;margin-right:15px" href="https://twitter.com/telldotafrica">
          <img class="alignnone wp-image-28421" src="https://i.ibb.co/yF5Hq15/twitter-1.png" alt="" width="21" height="21" />
          </a>
          

          <a style="color: #000000;margin-right:15px" href="https://instagram.com/tell.africa">
          <img class="alignnone wp-image-28422" src="https://i.ibb.co/HYMFS5D/instagram-1.png" alt="" width="21" height="21" />
          </a>

          
          <a style="color: #000000;margin-right:15px" href="https://linkedin.com/comoany/tellafrica">
          <img class="alignnone wp-image-28423" src="https://i.ibb.co/nsJMFYn/linkedin-1.png" alt="" width="21" height="21" />
          </a>
          

          <a style="color: #000000;margin-right:15px" href="https://youtu.be/4L3b6L3eL6g">
          <img class="alignnone wp-image-28424" src="https://i.ibb.co/7121z7Y/youtube.png" alt="" width="21" height="21" />
          </a>

          <p style="color:white;font-weight:500;text-align:center">Address: Lagos, Nigeria</p>

          </p>
          </div>
          </div>

             </div>`
             }
            }).then((response)=>{
              console.log(response)
            }).catch((error)=>{
              console.log(error)
            })
    },
    toPayment(payLoad) {
      this.e1 = 2;
      this.name = payLoad.name;
      this.email = payLoad.email;
      this.country = payLoad.country;
      this.bio = payLoad.bio;

      if (payLoad.image != null) {
        this.image = payLoad.image;
      } else {
        this.image = "https://i.ibb.co/Xkj8XZD/download.png";
      }

      this.uid = payLoad.uid;
    },
    toCustomization(payLoad) {
      this.bank = payLoad;
      this.e1 = 3;
    },
    activateOverlay() {
      this.overlayLoading = true;
    },
    deactivateOverlay() {
      this.overlayLoading = false;
    },
    async submit(payLoad) {
      this.loading = true;
      console.log(payLoad);
      const docRef = doc(db, "users", payLoad.username);
      const docSnap = await getDoc(docRef);
      if (docSnap._document != null) {
        this.$swal({
          title: "Username already taken",
          text:
            "Sorry buddy, looks like someone beat you to it 🥺. Please use another Username",
          icon: "error",
          confirmButtonText: "Okay"
        });
        this.loading = false;
      } else {
        setDoc(docRef, {
          name: this.name,
          email: this.email,
          phoneNumber: "",
          bio: this.bio,
          facebook: "",
          twitter: "",
          instagram: "",
          tiktok: "",
          youtube: "",
          linkedin: "",
          currency: this.country,
          bank: [this.bank],
          btncolor: payLoad.color,
          bg: payLoad.bg,
          username: payLoad.username,
          subscribers: [],
          wallet: 0,
          transactions: [],
          withdrawals: [],
          articles: [],
          videos: [],
          audios: [],
          buttons: [],
          tiktoks: [],
          notifications: [
            {
              title: "Welcome to Tippings!",
              message:
                "Congratulations, You have successfully created an account on Tippings",
              timestamp: moment(Date.now()).format("LLL")
            }
          ],
          uid: this.uid,
          securityPin: 1234,
          photoURL: this.image
        })
          .then(() => {
            const auth = getAuth();
            updateProfile(auth.currentUser, {
              displayName: this.name,
              photoURL: this.image
            });
          })
          .then(async () => {
            await axios({
              method: "post",
              url: "https://tips-api.herokuapp.com/mail",
              data: {
                from: "Teniola from Tippings <support@tippings.me>",
                email: this.email,
                replyTo: "support@tippings.me",
                title: "Welcome To Tippings 🎉 "+this.name,
                message: `
                  <div style="line-spacing:2.2;margin:0px 30px 0px 30px">
          <div style="text-align:center;width:50%:margin:auto">
          <div style=" text-align: center; width:300px; margin:auto auto 20px auto"> 
          <div style="position: relative;top: 10px;color: white;font-size: 13px;background: white;display: inline-block;padding: 0 20px;border-radius: 30px;">
          <img src="https://i.ibb.co/g7QwRGg/T.png" width="60px" height="60px" style="width:60px;text-align:center;margin:auto;border-radius:50%"/>
          </div>
          <div style="margin-top:20px;height:1px;background:black"></div>
        </div>
         </div>
                  <h1>Hi ${this.name}</h1> 
            <p>Thank you for taking the bold step of creating a Tippings account. We assure you that from this moment forward your journey as an African content creator will not remain the same </p>
            <p>Your Username on Tippings is <b>${payLoad.username}</b></p>
            <h2>What can you do on Tippings?</h2>
            <p>✓ Build and grow an audience that truly love your content</p>
            <p>✓ Seamlessly gain support and raise funds from your community </p>
            <p>✓ Build an emaillist and send out emails to your fans, for FREE!</p>
            <p>✓ Customize your Tippings page and showcase your creativity </p>

            <p style="margin-top:50px;margin-bottom:48px;text-align:center">To start customizing your Tippings page, tap the button below:
            <a style="color:white;text-decoration:none" href='https://tippings.me/${payLoad.username}'><p style="border-radius:12px;margin:auto;background:red;color:white;padding:19px 25px 19px 25px;width:165px">Customize your page </p></a>
            </p>
            
            <p style="margin-top:30px">If you need any support or have any complaints, please shoot an email to <a href="mailto:support@tippings.me">support@tippings.me</a>
            
            <br><br><p>Your personal assistant<br>Teniola</p>
             
             
             <div style="border:solid 4px black;background:black,color:white,padding:400px;display:flex">
          <div style="margin-top:60px;background-color: red; color: black; text-align: center; padding: 30px 20px 30px 20px;">
          <p style="text-align: center; color: white;">


          <a style="color: #000000;margin-right:15px" href="https://facebook.com/tell.com.ng">
          <img class="alignnone wp-image-28420" src="https://i.ibb.co/FzDN2DT/facebook-1.png" alt="" width="22" height="22" />
          </a>
          
          
          <a style="color: #000000;margin-right:15px" href="https://twitter.com/telldotafrica">
          <img class="alignnone wp-image-28421" src="https://i.ibb.co/yF5Hq15/twitter-1.png" alt="" width="21" height="21" />
          </a>
          

          <a style="color: #000000;margin-right:15px" href="https://instagram.com/tell.africa">
          <img class="alignnone wp-image-28422" src="https://i.ibb.co/HYMFS5D/instagram-1.png" alt="" width="21" height="21" />
          </a>

          
          <a style="color: #000000;margin-right:15px" href="https://linkedin.com/comoany/tellafrica">
          <img class="alignnone wp-image-28423" src="https://i.ibb.co/nsJMFYn/linkedin-1.png" alt="" width="21" height="21" />
          </a>
          

          <a style="color: #000000;margin-right:15px" href="https://youtu.be/4L3b6L3eL6g">
          <img class="alignnone wp-image-28424" src="https://i.ibb.co/7121z7Y/youtube.png" alt="" width="21" height="21" />
          </a>


           <p style="color:white;font-weight:500;text-align:center">Address: Lagos, Nigeria</p>

          </p>
          </div>
          </div>

             </div>`
             }
            });

            localStorage.setItem("tippingsKey", payLoad.username);
            this.$router.push("/dashboard");
            this.loading = false;
            //show success alert
            this.$swal({
              title: "Account created Successfully!",
              text:
                "Congratulations, you're now one of the cool kids who use Tippings",
              icon: "success",
              confirmButtonText: "Yay!"
            });
          })
          .catch(error => {
            this.loading = false
            this.overlayLoading = false
            console.log(error);
            this.$swal({
              title: "Something went wrong!",
              text:
                "Please try again by refreshing the page. Sorry for the incoveniences 😥",
              icon: "error",
              confirmButtonText: "Ok"
            });
          });
      }
    }
  }
};
</script>
